import { render } from "./SideScroll.vue?vue&type=template&id=16831a9e&scoped=true"
import script from "./SideScroll.vue?vue&type=script&lang=js"
export * from "./SideScroll.vue?vue&type=script&lang=js"

import "./SideScroll.vue?vue&type=style&index=0&id=16831a9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16831a9e"]])

export default __exports__